import Vue from 'vue';
// eslint-disable-next-line import/no-unresolved
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';

Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('VPopover', VPopover);
